export class Users {
  public id: number;
  public first_name: string;
  public middle_name: string;
  public last_name: string;
  public password: string;
  public remember_token: string;
  public status: number;
  public email: string;
  public department_id: number;
}
